export default {
  actionButton: 'سجّل اهتمامك لنتصل بك',
  submitButton: 'سجّل الآن',
  oneStepCloser: 'اقترب خطوة نحو امتلاك عقار أحلامك.',
  themeContentTitle: 'الحياة بأسلوب فنّي',
  themeContentDesc: 'في جزيرة السعديات',
  themeLaunchDesc:
    'شقق فاخرة من 1 إلى 3 غرف في المنطقة الثقافية بجزيرة السعديات',
  welcomeText:
    'أهلاً بكم في مشروع ذا أرت هاوس، حيث ينبض كل منزل بالفن والإبداع والراحة. اكتشف مساحة فريدة لحياة تنبض بأجواء الإلهام الحصرية المصممة للنخبة.',
  epicHeading: 'عش الرفاهية في قلب الثقافة على جزيرة السعديات',
  epicContentp1:
    'ذا أرت هاوس تحفة فنية جديدة تشع جمالاً وإلهاماً من قلب المنطقة الثقافية في السعديات، وتنفرد بموقع مميز على مقربة من متحف اللوفر أبوظبي، متحف التاريخ الطبيعي، متحف جوجنهايم أبوظبي، متحف زايد الوطني، تيم لاب فينومينا، ومركز فنون الأداء أبوظبي.',
  epicContentp2:
    'مكان مثالي يجد فيه السكان مصدراً متجدداً للإبداع والازدهار والإلهام.',
  exploreButton: 'اكتشف المنطقة الثقافية',
  epicLaunchHeading: 'عش الرفاهية في قلب الثقافة',
  epicLaunchContent:
    'ذا أرت هاوس تحفة فنية جديدة تشع جمالاً وإلهاماً من قلب المنطقة الثقافية في السعديات، وتنفرد بموقع مميز على مقربة من متحف اللوفر أبوظبي، متحف التاريخ الطبيعي، متحف جوجنهايم أبوظبي، متحف زايد الوطني، تيم لاب فينومينا، ومركز فنون الأداء أبوظبي. مكان مثالي يجد فيه السكان مصدراً متجدداً للإبداع والازدهار والإلهام.',
  productHeading: 'شقق فاخرة من 1 إلى 3 غرف حيث تتجسد الرفاهية في أدق التفاصيل',
  productContent:
    'تم تصميم كل مسكن ليغمرك بالأجواء الإبداعية الحصرية، مع الاهتمام الدقيق بكل التفاصيل، بدءًا من التصميمات الداخلية الأنيقة وحتى المساحات المشتركة المخططة بعناية، يعد ذا أرت هاوس معرضًا للعيش.',
  productButton: 'شاهد مخططات الطوابق',
  experienceHeading: 'أجواء إبداعية حصرية مصممة للنخبة',
  experienceContent:
    'ذا أرت هاوس مجتمع سكني حصري مصمم ليملأ حياتك بالإلهام والرقي والرفاهية. تنعم بلحظات الصفاء الجميلة في الحدائق الخضراء، واسترخِ في اللاونج قرب بركة السباحة على سطح المجمّع، واستمتع بمرافق من الطراز العالمي لترتقي بأسلوب حياتك وتلهم خيالك.',
  serviceHeading: 'استثمر في منزل فريد اليوم',
  serviceContent:
    'سواء كنت تبحث عن منزل فاخر للسكن في السعديات أو تريد تعزيز محفظتك الاستثمارية العقارية، فستجد خيارات استثنائية لا تضاهى في ذا أرت هاوس.',
  serviceTabOne: 'مرافق من الطراز العالمي',
  serviceTabTwo: 'نمو قيمة استثمارك',
  serviceTabThree: 'موقع فريد في جزيرة السعديات',
  contactHeading: 'احجز عقارك الآن',
  contactContent:
    'يسرنا اهتمامك في ذا أرت هاوس. سجّل اهتمامك للتواصل مع فريق مدراء مبيعاتنا المختصين. اكتشف المزيد عن مشروع ذا أرت هاوس في المنطقة الثقافية بجزيرة السعديات، واحصل على نصائح وإرشادات احترافية لامتلاك منزل أحلامك.',
  noVideoTagSupport: 'متصفحك لا يدعم علامة الفيديو.',
  formHeading: 'كن أول من يعرف المزيد',
  formDesc:
    'سجّل لتتحدث مع مدراء المبيعات المختصين لدينا حول مشروع ذا أرت هاوس في المنطقة الثقافية بجزيرة السعديات، واحصل على نصائح وإرشادات لامتلاك منزل أحلامك.',
  firstName: 'الاسم',
  lastName: 'الكنية',
  email: 'البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  reasonToBuy: 'سبب الشراء',
  nationality: 'الجنسية',
  residencyStatus: 'حالة الإقامة',
  reasonBuyOptionInvestor: 'استثمار',
  reasonBuyOptionHomeOwner: 'سكن',
  recieveUpdates:
    'نعم، أودّ الحصول على قائمة العقارات الفاخرة المعروضة للبيع، كما أنني مهتم بالحصول على نصائح احترافية شخصية ومعرفة أحدث تطورات السوق العقاري.',
  consentLabel: 'أوافق على',
  privacyPolicy: 'سياسة الخصوصية',
  termsAndConditions: 'شروط الاستخدام',
  consentLabelEnd: 'من الدار',
  footerContactTitle: 'تواصل معنا:',
  launchFooterContactTitle: 'نرحب بكم،',
  footerContactCallText: 'اتصل على',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'تطوير شركة الدار العقارية',
  successHeading: 'شكراً عل تسجيل اشتراكك',
  successContent:
    'يتطلع فريق مدراء مبيعاتنا للتواصل معك. ترقب رسائلنا في صندوق بريدك الإلكتروني للاطلاع على أخر التحديثات الحصرية. وإذا كنت مهتماً بمعرفة المزيد عن عروض الدار، اكتشف مرافقنا الأخرى ذات الطراز العالمي في قلب المنطقة الثقافية بجزيرة السعديات',
  metaTitle: 'ذا أرت هاوس: الحياة بأسلوب فنّي',
  metaDescription:
    'اكتشف أحدث مشاريع الدار: مجتمع سكني مميز ينفرد بأجواء إبداعية حصرية مصممة للنخبة في المنطقة الثقافية في السعديات',
  launchWelcomeText:
    'أهلاً بكم في مشروع  ذا أرت هاوس، حيث ينبض كل منزل بالفن والإبداع والراحة. اكتشف مساحة فريدة لحياة تنبض بأجواء الإلهام الحصرية المصممة للنخبة.',
  experienceTab1main: 'الردهة الرئيسية',
  experienceTab1sub: 'بهو واسع و معرض فني يتميز بأناقة والفخامة',
  experienceTab2main: 'استوديو الفنون',
  experienceTab2sub:
    'مساحة فريدة مخصصة للمبدعين مع مساحات عمل مشتركة و صالة عرض فنية',
  experienceTab3main: 'المجلس الإبداعي',
  experienceTab3sub:
    'مفهوم عصري فريد للمجلس التقليدي يتجسد في ردهة استقبال خاصة تزينها اللمسات الفنّية الملهمة',
  experienceTab4main: 'سكاي جاردن',
  experienceTab4sub:
    'ركن ترفيهي على السطح مع منطقة جلوس أنيقة وإطلالات بانورامية مبهرة على أفق المدينة والبحر',
  experienceTab5main: 'سينما آرت هاوس',
  experienceTab5sub: 'عروض أفلام حصرية فاخرة لعشاق السينما',
  experienceTab6main: 'ردهة الترفيه',
  experienceTab6sub: 'غرفة ألعاب حصرية للاسترخاء والترفيه',
  experienceTab7main: 'ركن العشاء',
  experienceTab7sub:
    'مطبخ للطهاة ومنطقة لتناول الطعام في مطبخ اجتماعي راقٍ لتجمعات لا تُنسى',
  experienceTab8main: 'النادي الصحي',
  experienceTab8sub: 'ملاذ لمحبين اللياقة البدنية مصمم للنخبة',
  experienceTab9main: 'كور ستوديو',
  experienceTab9sub: 'مساحة هادئة لتجديد النشاط والاسترخاء',
  experienceTab10main: 'ملعب تنس',
  experienceTab10sub: 'ملعب لتطوير المهارات الرياضية',
  experienceTab11main: 'الحديقة السرّية',
  experienceTab11sub:
    'حدائق استوائية ومناظر طبيعية خلابة مُعتنى بها بعناية للتنزه',
  experienceTab12main: 'برك للسباحة',
  experienceTab12sub: 'للكبار والصغار على السطح العلوي تتميز بإطلالات خلابة',
  experienceTab13main: 'غرفة ألعاب للأطفال',
  experienceTab13sub: 'مساحة تفاعلية للأطفال لتعزيز إبداعهم',
  experienceTab14main: 'مساحات عمل مشتركة',
  experienceTab14sub:
    'هدفها توفير بيئة عمل محفزة تجمع بين التصميم المبدع والإنتاجية، وتشجع على التفاعل والتواصل بين الأشخاص',
  contactCommentsPlaceholder: 'هل لديك أي ملاحظة أو سؤال؟',
  residencyStatusOptionResident: 'مقيم',
  residencyStatusOptionNonResident: 'غير مقيم',
  successButton: 'اكتشف المزيد من المجتمعات',
  headerActionButton: 'Go to Aldar.com',
};
